// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  businessSectorUrl: 'https://devsrv-02.it-cores.com:220',
  businessSectorApiUrl: 'https://devsrv-02.it-cores.com:220/api',
  financialSectorUrl: 'https://devsrv-02.it-cores.com:520',
  financialSectorApiUrl: 'https://devsrv-02.it-cores.com:520/api',

  businessSectorUiUrl: 'https://devsrv-02.it-cores.com/#',
  // businessSectorUrl: 'https://localhost:44326',
  // businessSectorApiUrl: 'https://localhost:44326/api',
  businessSectorExternalApiUrl: '//devsrv-02.it-cores.com/api',

  sharedModuleUrl: 'devsrv-02.it-cores.com',
  // sharedModuleUrl: 'https://localhost:44387',
  sharedModuleApiUrl: 'https://devsrv-02.it-cores.com:230/api',
  //sharedModuleApiUrl: "https://localhost:44387/api",
  // financialSectorUrl: 'https://localhost:44392',
  // financialSectorApiUrl: 'https://localhost:44392/api',

  customerPortalUiUrl: 'http://devsrv-02.it-cores.com/#',

  reportingApiUrl: 'https://devsrv-02.it-cores.com:41',
  // reportingApiUrl: 'https://localhost:44372',

  arcoUiUrl: 'https://devsrv-02.it-cores.com',
  arcoLoginUrl: 'https://devsrv-02.it-cores.com/',
  arcoApiUrl: 'https://devsrv-02.it-cores.com/api',
  arcoHrApiUrl: 'https://devsrv-02.it-cores.com/ManpowerApp',//'https://manpowertest.azurewebsites.net',

  arcoNotificationApiUrl: 'https://devsrv-02.it-cores.com/api/Notification',

  lang: 'en',
  tokenKey: 'token',
  mapsApiKey: 'AIzaSyCuOIwdD1-9ea7ETsj4dwHu7Fgn3Uio9OM',
  maxDocumentSize: 2097152,
  autoCompleteDelay: 1000,
  timerKey: 'idleTimer',
  maxIdleTimeKey: 'maxIdleTime',
  maxIdleTime: 60,
  sessionCountDownTimerInMinutes: 30,
  useFakeAuthServer: false,
  excludeModuleId: 'SharedModule',

  financialSectorApiScopeUri: 'api://b6d2bf03-c948-446b-a464-6eea768c7c48/FinSecAPI.Access.BusSecUI',
  businessSectorApiScopeUri: 'api://09e7bfa1-7a72-4f4a-a729-92429f0bb2dc/BusSecAPI.Access',
  tenantId: '95301f51-c0ab-48d6-9abc-22c60aa1cdb8',
  clientId: 'd041f3cb-65fe-46ee-8975-43446b704b12',
  graphScopes: ['user.read', 'openid', 'profile'],
  // redirectUrl: 'http://localhost:4200/Business/auth/login'
  redirectUrl: 'http://devsrv-02.it-cores.com/Business/auth/login'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
